import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserInfoService } from '../user-info/user-info.service';
import { Entity } from './entity.interface';

const protobuf = require('protobufjs');

@Injectable()
export class EntityClass implements Entity {
  private _listValues: any = { admin: [], user: [], nurse: [], other: [] };
  private _itemValues: any = { admin: {}, user: {}, nurse: {}, other: {} };
  entityReducer: Observable<any>;
  sub: Subscription;
  listChanged = true;

  private httpMethod(method: string, paramsArray: Array<any>) {
    if (environment.isMock && method !== 'get' && method !== 'delete') {
      paramsArray.splice(1, 1);
    }
    if (environment.isMock) {
      return this.http.get(environment.baseUrl + 'api/empty-mock.json', paramsArray[1]);
    } else {
      switch (method) {
        case 'post':
          return this.http.post(paramsArray[0], paramsArray[1], paramsArray[2]);
        case 'patch':
          return this.http.patch(paramsArray[0], paramsArray[1], paramsArray[2]);
        case 'put':
          return this.http.put(paramsArray[0], paramsArray[1], paramsArray[2]);
        case 'delete':
          return this.http.delete(paramsArray[0], paramsArray[1]);
        default:
          return this.http.get(paramsArray[0], paramsArray[1]);
      }
    }
  }

  removePrototypes(obj: any): any {
    delete obj.constructor;
    delete obj.$type;
    delete obj.toJSON;
    delete obj.toObject;
    return obj;
  }

  get listValues(): any {
    return this._listValues[this.getRole().name];
  }

  set listValues(value: any) {
    this._listValues[this.getRole().name] = value;
    this.store.dispatch({ type: this['name'] + '_' + 'listValues', payload: value });
  }

  get itemValues(): any {
    return this._itemValues[this.getRole().name];
  }

  set itemValues(value: any) {
    this._itemValues[this.getRole().name] = value;
    this.store.dispatch({ type: this['name'] + '_' + 'itemValues', payload: value });
  }

  // listValues: {}[] = [];
  // itemValues: {} = {};

  constructor(public http: Http, public router: Router, public location: Location, public userInfo: UserInfoService, public store: Store<any>) {
    this.entityReducer = store.select('entity');
    // this.sub=this.entityReducer.subscribe((value)=>{
    // });
  }

  public getRole(): { name: string, token: string } {
    const roles = ['admin', 'user', 'nurse'];
    let token = '';
    let role = 'other';
    for (const r of roles) {
      if (this.userInfo.userInfo[r + 'Info']) {
        // if (this.userInfo.userInfo[r + 'Info'] && (this.location.path() as string).indexOf('/' + r + '/') >= 0) {
        token = this.userInfo.userInfo[r + 'Info'].token;
        role = r;
        break;
      }
    }
    return { name: role, token: token };
  }

  public initRequestOptions(query?: Object) {
    const role = this.getRole();
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE,PATCH, OPTIONS');
    headers.append('Access-Control-Allow-Headers', 'X-Requested-With');
    headers.append('Content-Type', 'application/json');
    headers.append('crossDomain', 'true');
    headers.append('Authorization', role.token);
    headers.append('Role', role.name);
    return query ? { headers: headers, params: query } : { headers: headers };
  }

  private prefixUrl(method, url, params, id?): string {
    params = Object.assign(params, { role: this.getRole().name });
    for (const name in params) {
      if (((typeof params[name]) === 'string' || (typeof params[name]) === 'number') /*&& params[name] !== ''*/) {
        url = url.replace(new RegExp('{' + name + '}', 'gm'), params[name]);
      }
    }
    if (url.indexOf('{') >= 0) {
      throw { result: { success: false, displaymsg: 'params is not resolve' } };
    }
    const urlArray = url.split('?');
    if (!this['noRESTful'] && id !== '') {
      if (id === undefined) {
        console.error('id in invalid');
      }
      urlArray[0] = urlArray[0] + '/' + id;
    }
    urlArray[0] += (environment.isMock ? ('/' + method + '.json') : '');
    return urlArray.join('?');
  }

  private patchItem(oData, pData) {
    if (this['root'] === 'root') {
      return;
    }
    for (const p in pData) {
      if (p) {
        oData[p] = pData[p];
      }
    }
  }

  private updateItem(response: any) {
    // if (this['root'] == 'root' || !response[this['idName']]) {
    //   return;
    // }
    if (this['noCache']) {
      return;
    }
    if (!response.data) {
      response.data = {};
      return;
    } else if (response.result.success || response.code === 0) {
      if (this['root'] !== 'root') {
        response = response.data[this['root']];
      } else {
        response = response.data;
      }
      this.itemValues[response[this['idName'] || '']] = this.itemValues[response[this['idName'] || '']] || {};
      this.patchItem(this.itemValues[response[this['idName'] || '']], response);
      if (this['noGetList'] !== true) {
        if (this.listValues.filter(item => item[this['idName']] === response[this['idName']]).length === 0) {
          const newData = {};
          newData[this['idName']] = response[this['idName']];
          this.listValues.push(newData);
        }
        this.patchItem(this.listValues.filter(item => item[this['idName']] === response[this['idName']])[0], response);
      }
    }
  }

  private delItem(id: number | string) {
    if (this['root'] === 'root') {
      return;
    }
    delete this.itemValues[id];
    let index;
    for (index = 0; index < this.listValues.length; index++) {
      if (this.listValues[index][this['idName']] === id) {
        this.listValues.splice(index, 1);
        return;
      }
    }
  }

  private getMockByFields(fName, fields) {
    let tValue;
    switch (fName) {
      case 'gender':
        tValue = Math.floor(Math.random() * 2);
        break;
      default:
        switch (fields[fName].type) {
          case 'string':
            tValue = `mock:${fName}`;
            break;
          case 'float':
          case 'double':
          case 'int32':
          case 'int64':
          case 'uint32':
          case 'uint64':
          case 'sint32':
          case 'sing64':
          case 'sfixed32':
          case 'sfixed64':
            tValue = Math.floor(Math.random() * 10);
            break;
          case 'bool':
            tValue = Math.floor(Math.random() * 2) === 0;
            break;
          default:
            tValue = this.createMock(fields[fName].type);
        }
    }
    return tValue;
  }

  public createMock(protobufModuleName): any {
    const protobufRoot = protobuf.Root.fromJSON(this['protobufJSON']);
    const protobufModule = protobufRoot.lookup(protobufModuleName);
    const data = protobufModule.create({});
    for (const fName in protobufModule.fields) {
      if (protobufModule.fields[fName].repeated) {
        data[fName] = [];
        const count = 1 + Math.floor(Math.random() * 3);
        for (let i = 0; i < count; i++) {
          data[fName].push(this.getMockByFields(fName, protobufModule.fields));
        }
      } else {
        data[fName] = this.getMockByFields(fName, protobufModule.fields);
      }
    }
    return data;
  }

  public mapping(response: any, defaultValue: any = {}): any {
    let d: any = {};
    d = Object.assign(d, response);
    delete d.result;
    delete d.data;
    if (response.data) {
      d = Object.assign(d, response.data);
    }
    if (d === {}) {
      d = defaultValue;
    }
    response.data = d;
    // 添加code === 0 的情况下的接口数据接收
    if ((response.result && response.result.success) || response.code === 0) {
      const result: any = response.result;
      if (this['root'] === 'none') {
        return { result: result };
      }
      // response.data = response.data || {};
      let data: any = response.data;
      // data = data[this['root']];
      if (this['root'] !== 'root') {
        data = data ? (data[this['root']] || defaultValue) : defaultValue;
      } else {
        data = data || defaultValue;
      }
      if (this['root'] === 'none') {
        return { result: result };
      }
      if (this['protobufJSON'] && this['protobufModule']) {
        const protobufRoot = protobuf.Root.fromJSON(this['protobufJSON']);
        const protobufModule = protobufRoot.lookup(this['protobufModule']);
        // if (data === undefined) {
        //   let nData = undefined;
        //   if (this['root'] == 'none') {
        //     nData = {};
        //     nData[this['root']] = undefined;
        //   }
        //   return {data: nData, result: result};
        // }
        if (data !== {}) {
          if (data.length === undefined) {
            data = Object.assign(protobufModule.create(data), { toJSON: undefined });
          } else {
            const dataArray = [];
            for (const r of data) {
              dataArray.push(Object.assign(protobufModule.create(r), { toJSON: undefined }));
            }
            data = dataArray;
          }
        }
        if (environment.isMock) {
          if (data.length !== undefined) {
            let count = 1 + Math.floor(Math.random() * 3);
            if (data.length > 0) {
              count = 0;
            }
            for (let i = 0; i < count; i++) {
              data.push(this.createMock(this['protobufModule']));
            }
          } else {
            data = this.createMock(this['protobufModule']);
          }
        }
      }
      let resultData: any = {};
      if (this['root'] === 'root') {
        resultData = data;
      } else {
        resultData[this['root']] = data;
      }
      // TODO 修改
      if (response.code === 0) {
        return {
          data: response.data, result: {
            code: response.code,
            success: true,
          }
        };
      }

      return { data: resultData, result: result };
    } else {
      if (!(response.result.code === 403 || response.result.code === 401)) {
        if (parseInt(response.result.code, 0) > 10000 || response.result.code === 500) {
          swal('服务器错误', response.result.displaymsg, 'error');
        } else if (response.result.displaymsg) {
          swal('服务器错误', response.result.displaymsg, 'error');
        }
      } else {
        this.router.navigateByUrl('/admin/login');
        swal({
          title: '权限错误?',
          text: '请重新登录后重试',
          type: 'warning',
          showCancelButton: false,
          // confirmButtonColor: "#DD6B55",
          confirmButtonText: '确定',
          closeOnConfirm: true
        },
          () => {
            this.router.navigateByUrl('/' + this.getRole().name + '/login');
          });
      }
      if (parseInt(response.result.code, 0) > 10000 || response.result.code === 500) {
        swal('服务器错误', response.result.displaymsg, 'error');
      } else if (response.result.displaymsg) {
        swal('请求失败', response.result.displaymsg, 'warning');
      }
      throw { result: response.result };
    }
  }


  getList(params: Object = {}, force: boolean = this['url'].indexOf('{') >= 0 || true, query?: Object): Observable<any> {
    if (this['noGetList']) {
      return Observable.create((subscriber) => {
        subscriber.next({
          data: [],
          result: {
            code: -1,
            success: false
          }
        });
      });
    }

    force = force || this.listChanged;

    if (!force && this.listValues.length > 0) {
      let resultData: any = { data: {}, result: { code: 0, success: true } };
      if (this['root'] !== 'root') {
        resultData.data[this['root']] = this.removePrototypes(this.listValues);
      } else {
        resultData.data = this.removePrototypes(this.listValues);
      }
      resultData = this.mapping(resultData, []);
      return Observable.create((subscriber) => {
        subscriber.next(resultData);
      });
    } else {
      return this.httpMethod('get', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('getList', this['url'], params, ''),
      query ? this.initRequestOptions(query) : this.initRequestOptions()])
        .map((response: any) => {
          response = response.json();
          let d = {};
          d = Object.assign(d, response);
          if (response.data) {
            d = Object.assign(d, response.data);
          } else {
            const td = {};
            td[this['root']] = [];
            d = Object.assign(d, td);
          }
          response.data = d;
          // return response;
          return this.mapping(response, []);
        })
        .map((response) => {
          this.listChanged = false;
          response.data = response.data || [];

          if (!this['noCache']) {
            if (this['root'] !== 'root') {
              this.listValues = response.data[this['root']] || [];
            } else {
              this.listValues = response.data;
            }
          }
          return response;
        });
    }
  }

  get(id: number | string, params: Object = {}, force: boolean = this['url'].indexOf('{') >= 0 || true, query?: Object): Observable<any> {
    if (this['getMethodReturnFromList']) {
      return this.getList(force).map(() => {
        // return Observable.create((subscriber) => {
        const obj = this.listValues.filter((item) => item[this['idName']] === id);
        if (obj.length > 0) {
          let resultData: any = { data: {}, result: { code: 0, success: true } };
          if (this['root'] !== 'root') {
            resultData.data[this['root']] = obj[0];
          } else {
            resultData.data = obj[0];
          }
          resultData = this.mapping(resultData);
          return resultData;
          // return Observable.create((subscriber) => {
          //   subscriber.next(resultData);
          // });
        } else {
          throw new Error('id is not found from list');
        }
        // });
      });
    } else if (!force && this.itemValues[id]) {
      return Observable.create((subscriber) => {
        let data = {};
        if (this['root'] !== 'root') {
          data[this['root']] = this.removePrototypes(this.itemValues[id]);
        } else {
          data = this.removePrototypes(this.itemValues[id]);
        }
        subscriber.next({ data: data, result: { success: true } });
      });
    } else {
      return this.httpMethod('get', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('get', this['url'], params, id),
      query ? this.initRequestOptions(query) : this.initRequestOptions()])
        .map((response) =>
          this.mapping(response.json()))
        .map((response) => {
          response.data = response.data || {};
          this.updateItem(response);
          return response;
        });
    }
  }

  post(params: {}, query?: Object): Observable<any> {

    return this.httpMethod('post', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('post', this['url'], params, ''), params,
    query ? this.initRequestOptions(query) : this.initRequestOptions()])
      .map((response) =>

        this.mapping(response.json()))
      .map((response) => {
        this.updateItem(response);
        return response;
      });
  }

  put(id: number | string, params: {}, query?: Object): Observable<any> {

    return this.httpMethod('put', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('put', this['url'], params, id), params,
    query ? this.initRequestOptions(query) : this.initRequestOptions()])
      .map((response) =>
        this.mapping(response.json()))
      .map((response) => {
        this.updateItem(response);
        return response;
      });
  }

  patch(id: number | string, params: {}, query?: Object): Observable<any> {

    return this.httpMethod('patch', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('patch', this['url'], params, id), params,
    query ? this.initRequestOptions(query) : this.initRequestOptions()])
      .map((response) =>
        this.mapping(response.json()))
      .map((response) => {
        this.updateItem(response);
        return response;
      });
  }

  del(id?: number | string, params?: {}, query?: Object): Observable<any> {

    return this.httpMethod('delete', [(this['baseUrl'] ? this['baseUrl'] : environment.baseUrl) + this.prefixUrl('del', this['url'], params, id),
    query ? this.initRequestOptions(query) : this.initRequestOptions()])
      .map((response) =>
        this.mapping(response.json()))
      .map((response) => {
        this.delItem(id);
        return response;
      });
  }

  // 改写post
  newAdd(params: {}, query?: Object): Observable<any> {

    return this.httpMethod('post', [environment.baseUrl + this.prefixUrl('post', this['url'], params, ''), params,
    query ? this.initRequestOptions(query) : this.initRequestOptions()])
      .map((response) =>
        this.mapping(response.json()))
      .map((response) => {
        return response;
      });
  }


}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity.class.ts